import { CoreModel } from '../core/core.model';
import { ButtonModel } from '../button/button.model';
import { Transfer } from '../../components/file-uploader/ng2-file-uploader/source/transfer.core';
export class FileUploaderModel extends CoreModel {
/**
 * <p>It is an object of type Transfer with next properties:</p>
 * <ul>
 * <li><pre><b>url</b>: string</pre><p>Path to server where the files be uploaded. Optional. Default: ''.</p></li>
 * <li><pre><b>alias</b>: string</pre><p>File alias. Optional. Default: 'file'.</p></li>
 * <li><pre><b>headers</b>: Object</pre><p>An object with header informations. Optional. Default: {{'{'}}{{'}'}}.</p></li>
 * <li><pre><b>filters</b>: FileFilter[]</pre><p>A list of filters which are extend the default list. Optional. Default: [].</p></li>
 * <li><pre><b>formData</b>: Object[]</pre><p>A list of data to be sent along with the files. Optional. Default: [].</p></li>
 * <li><pre><b>autoUpload</b>: boolean</pre><p>Automatically upload new
 * files when they are adding to the queue. Optional. Default: false.</p></li>
 * <li><pre><b>method</b>: string</pre><p>Request methode - HTML5 only. Optional. Default: 'POST'.</p></li>
 * <li><pre><b>removeBySuccess</b>: boolean</pre><p>Remove file from queue
 * when upload was successfull. Optional. Default: false.</p></li>
 * <li><pre><b>queueLimit</b>: number</pre><p>Limitation of files at the queue (-1 is unlimited). Optional. Default: -1.</p></li>
 * <li><pre><b>enableCors</b>: boolean</pre><p>Activate CORS - HTML5 only. Optional. Default: false.</p></li>
 * <li><pre><b>withCredentials</b>: boolean</pre><p>If to use credentials. Optional. Default: false.</p></li>
 * <li><pre><b>uniqueFiles</b>: boolean</pre><p>To add only unique files to files list. Optional. Default: false.</p></li>
 * </ul>
 */
main?: any;
/**
 * Means if read files content after file was added to the list
 */
readFiles?: boolean;
/**
 * Means if component must show dropZone.
 */
showDropZone?: boolean;
/**
 * Means label for dropZone.
 */
dropZoneLabel?: string;
/**
 * Means part or all text of file name to match
 */
filesNames?: string[];
/**
 * Means what file types are resolved to add
 */
filesTypes?: string[];
/**
 * Means what files by size are resolved to add
 */
filesSizes?: string[];
/**
 * Means what files by date are resolved to add
 */
filesDates?: string[];
/**
 * Means if to show actions for all selected files.
 */
showFilesActions?: boolean;
/**
 * Means if to show actions for a single file.
 */
showFileActions?: boolean;
/**
 * ButtonModel for each file upload
 */
uploadFileButton?: ButtonModel;
/**
 * ButtonModel for each file remove
 */
removeFileButton?: ButtonModel;
/**
 * ButtonModel for upload all files
 */
uploadFilesButton?: ButtonModel;
/**
 * ButtonModel for remove all files
 */
removeFilesButton?: ButtonModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function FileUploaderModel_tsickle_Closure_declarations() {
/**
 * <p>It is an object of type Transfer with next properties:</p>
 * <ul>
 * <li><pre><b>url</b>: string</pre><p>Path to server where the files be uploaded. Optional. Default: ''.</p></li>
 * <li><pre><b>alias</b>: string</pre><p>File alias. Optional. Default: 'file'.</p></li>
 * <li><pre><b>headers</b>: Object</pre><p>An object with header informations. Optional. Default: {{'{'}}{{'}'}}.</p></li>
 * <li><pre><b>filters</b>: FileFilter[]</pre><p>A list of filters which are extend the default list. Optional. Default: [].</p></li>
 * <li><pre><b>formData</b>: Object[]</pre><p>A list of data to be sent along with the files. Optional. Default: [].</p></li>
 * <li><pre><b>autoUpload</b>: boolean</pre><p>Automatically upload new
 * files when they are adding to the queue. Optional. Default: false.</p></li>
 * <li><pre><b>method</b>: string</pre><p>Request methode - HTML5 only. Optional. Default: 'POST'.</p></li>
 * <li><pre><b>removeBySuccess</b>: boolean</pre><p>Remove file from queue
 * when upload was successfull. Optional. Default: false.</p></li>
 * <li><pre><b>queueLimit</b>: number</pre><p>Limitation of files at the queue (-1 is unlimited). Optional. Default: -1.</p></li>
 * <li><pre><b>enableCors</b>: boolean</pre><p>Activate CORS - HTML5 only. Optional. Default: false.</p></li>
 * <li><pre><b>withCredentials</b>: boolean</pre><p>If to use credentials. Optional. Default: false.</p></li>
 * <li><pre><b>uniqueFiles</b>: boolean</pre><p>To add only unique files to files list. Optional. Default: false.</p></li>
 * </ul>
 * @type {?}
 */
FileUploaderModel.prototype.main;
/**
 * Means if read files content after file was added to the list
 * @type {?}
 */
FileUploaderModel.prototype.readFiles;
/**
 * Means if component must show dropZone.
 * @type {?}
 */
FileUploaderModel.prototype.showDropZone;
/**
 * Means label for dropZone.
 * @type {?}
 */
FileUploaderModel.prototype.dropZoneLabel;
/**
 * Means part or all text of file name to match
 * @type {?}
 */
FileUploaderModel.prototype.filesNames;
/**
 * Means what file types are resolved to add
 * @type {?}
 */
FileUploaderModel.prototype.filesTypes;
/**
 * Means what files by size are resolved to add
 * @type {?}
 */
FileUploaderModel.prototype.filesSizes;
/**
 * Means what files by date are resolved to add
 * @type {?}
 */
FileUploaderModel.prototype.filesDates;
/**
 * Means if to show actions for all selected files.
 * @type {?}
 */
FileUploaderModel.prototype.showFilesActions;
/**
 * Means if to show actions for a single file.
 * @type {?}
 */
FileUploaderModel.prototype.showFileActions;
/**
 * ButtonModel for each file upload
 * @type {?}
 */
FileUploaderModel.prototype.uploadFileButton;
/**
 * ButtonModel for each file remove
 * @type {?}
 */
FileUploaderModel.prototype.removeFileButton;
/**
 * ButtonModel for upload all files
 * @type {?}
 */
FileUploaderModel.prototype.uploadFilesButton;
/**
 * ButtonModel for remove all files
 * @type {?}
 */
FileUploaderModel.prototype.removeFilesButton;
}

